import { render, staticRenderFns } from "./MyNotesPage.vue?vue&type=template&id=57514ef7&scoped=true"
import script from "./MyNotesPage.vue?vue&type=script&lang=js"
export * from "./MyNotesPage.vue?vue&type=script&lang=js"
import style0 from "./MyNotesPage.vue?vue&type=style&index=0&id=57514ef7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57514ef7",
  null
  
)

export default component.exports